export default "__VITE_ASSET__buJOLoTk__"